<script>
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue";
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue";
import {useLikeStore} from "@js/store/LikeStore.js";
import CatalogProductItem from "@js/components/Sections/Catalog/ProductItem/CatalogProductItem.vue";
import CatalogProductSkeleton from "@js/components/Sections/Catalog/ProductItem/CatalogProductSkeleton.vue";
import IconHeartFilled from "@js/components/Icons/IconHeartFilled.vue";

export default {
    name: "LikedProductsPage",
    components: {IconHeartFilled, CatalogProductSkeleton, CatalogProductItem, Breadcrumbs, MobileTopBar},
    mounted() {
        this.likeStore.getLikedProductsData()
    },
    setup() {
        const likeStore = useLikeStore()

        return {likeStore}
    }
}
</script>

<template>
    <MobileTopBar/>
    <div class="container">
        <Breadcrumbs/>
        <h1 class="flex items-center text-2xl font-bold mb-5">
            Избранные продукты
        </h1>
        <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
            <template v-if="!likeStore.loading_products">
                <CatalogProductItem v-for="(product, key) in likeStore.products"
                                    :data="product" :key="key"/>
            </template>
            <template v-else>
                <CatalogProductSkeleton v-for="i in 9"/>
            </template>
        </div>
        <div v-if="!likeStore.loading_products && !likeStore.products.length">
            <div class="flex flex-col items-center justify-center w-full bg-white p-5 border border-gray-200 shadow rounded-xl">
                <div class="flex items-center justify-center border border-gray-200 rounded-full p-4 md:p-5 mb-5">
                    <IconHeartFilled class="w-7 h-7 text-red-600"/>
                </div>
                <div class="text-xl md:text-2xl font-bold text-gray-800 text-center mb-2">
                    У вас пока нет избранных товаров
                </div>
                <div class="text-sm md:text-base font-bold text-gray-800 text-center">
                    Перейдите в каталог и добавьте товары в избранное
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">

</style>
